<template>
  <!--<li :class="classes"><slot></slot></li>-->
  <router-link
    :class="classes"
    active-class="sider-item-active"
    :to="{ name: name }"
  >
    <slot></slot>
  </router-link>
</template>

<script>
import "@/styles/component/sider.less";
export default {
  name: "side-menu-item",
  props: {
    name: {
      type: [String, Number],
      required: true
    }
  },
  mounted() {
    this.$on("update-active-name", name => {
      this.active = this.name === name;
    });
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    classes() {
      return [
        "sider-item"
        // {
        //   "sider-item-active": this.active
        // }
      ];
    }
  }
};
</script>
